import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import MutasiAngsuran from "./pdf/mutasiangsuranpdf";

function MutasiAngsuranComp() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [loading, setLoading] = useState(false);
  const [jenisTransaksi, setJenisTransaksi] = useState("D");
  const [kelompok, setKelompok] = useState("Angsuran");
  const [isExporting, setIsExporting] = useState(false);

  const handleSubmit = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setLoading(true);

    try {
      
      const response = await api.get(`/api/laporan/mutasiangsuran/${periode}`);  
      const result = await response.data.data;
      const allData = result || [];

      if (jenisTransaksi === "D") {
        const filteredA = allData.filter(item => item.sldawal_ua || item.angsur_a || item.layanan_a || item.sldjasa_a || item.sldgermen_a);
        if (filteredA.length > 0) {
          MutasiAngsuran(periode, filteredA, namaBulan, tahun, "D", kelompok);
        } else {
          alert("Data Angsuran D tidak ditemukan.");
        }

      } else if (jenisTransaksi === "C") {
        const filteredB = allData.filter(item => item.sldawal_ub || item.angsur_b || item.layanan_b || item.sldjasa_b);
        if (filteredB.length > 0) {
          MutasiAngsuran(periode, filteredB, namaBulan, tahun, "C", kelompok);
        } else {
          alert("Data Angsuran C tidak ditemukan.");
        }
      }
    } catch (error) {
      console.error("Gagal fetch:", error);
      alert(`Terjadi kesalahan: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setIsExporting(true);
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/exsportexcell/mutasiangsuran/${periode}/${jenisTransaksi}/${kelompok}`, {
        responseType: 'blob',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      const filename = `Mutasi_${kelompok}_${jenisTransaksi}_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export Excel error:', err);
      alert('Gagal mengekspor Excel.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: "400px" }}>
            <div className="card-header">
              <h5 className="card-title">Laporan Mutasi Angsuran Piutang</h5>
            </div>
            <div className="card-body">
              <form className="form-horizontal">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select className="form-control" value={selectedBulan} onChange={e => setSelectedBulan(parseInt(e.target.value, 10))}>
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>{item}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select className="form-control" value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Jenis</label>
                  <div className="col-sm-6">
                    <select className="form-control" value={jenisTransaksi} onChange={e => setJenisTransaksi(e.target.value)}>
                      <option value="D">Angsuran D</option>
                      <option value="C">Angsuran C</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Kelompok</label>
                  <div className="col-sm-6">
                    <select className="form-control" value={kelompok} onChange={e => setKelompok(e.target.value)}>
                      <option value="Angsuran">Angsuran</option>
                      <option value="Germen">Germen</option>
                      <option value="Jasa">Jasa</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn btn-sm btn-primary mr-2" onClick={handleSubmit} disabled={loading}>
                {loading ? "Memproses..." : "Cetak"}
              </button>
              <button className="btn btn-sm btn-success" onClick={handleExportExcel} disabled={isExporting}>
                {isExporting ? "Mengekspor..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiAngsuranComp;

